<template>
  <div>
    <base-doughnut-chart
      v-show="!printable || (!imgData && printable)"
      :height="height ? height : null"
      :chart-data="getChartData"
      :options="getChartOptions"
      @chartCreated="setChart"
    />
    <img :height="height ? height : 200" :src="imgData" v-show="printable && imgData">
  </div>
</template>

<script>
import chartMixin from './mixins/chartMixin';

import BaseDoughnutChart from './base/BaseDoughnutChart';

export default {
  name: 'DoughnutChart',
  mixins: [chartMixin],
  components: {
    BaseDoughnutChart,
  },
  data: () => ({
    chart: null,
    imgData: null,
  }),
  props: {
    height: {
      type: Number,
    },
    printable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setChart(chart) {
      this.chart = chart;
    },
    animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    },
  },
};
</script>



// WEBPACK FOOTER //
// DoughnutChart.vue?52400864